import { useDispatch } from '@redux/store';

import { runPiecePageInitiationQueries } from '../api';
import { IThumbnail, IThumbnailId, PiecePageInitiationData, PiecePageInitiationImages } from './../types';

export const usePiecePageInitiation = () => {
  const dispatch = useDispatch();

  const runPiecePageInitiation = (
    data: PiecePageInitiationData,
    images: PiecePageInitiationImages,
    onComplete: (thumbnail: IThumbnail, operationId: IThumbnailId) => void,
    onError: (operationId: IThumbnailId) => void,
  ) => {
    runPiecePageInitiationQueries(data, images, dispatch)
      .then((thumbnail) => {
        onComplete(thumbnail as IThumbnail, data.thumbnail.id);
      })
      .catch(() => onError(data.thumbnail.id));

    return data.thumbnail.id;
  };

  return { runPiecePageInitiation };
};
